"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tertiary = exports.Secondary = exports.Primary = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var Button = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  box-sizing: border-box;\n  outline: 0;\n  margin: 0;\n  padding: 0;\n  font-family: ", ";\n  border-radius: 20px;\n  height: 40px;\n  width: 200px;\n  border: 1px solid;\n  font-size: 14px;\n  box-sizing: border-box;\n\n  &:active {\n    background: ", ";\n    color: ", ";\n  }\n\n  &.circular {\n    width: 40px;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  box-sizing: border-box;\n  outline: 0;\n  margin: 0;\n  padding: 0;\n  font-family: ", ";\n  border-radius: 20px;\n  height: 40px;\n  width: 200px;\n  border: 1px solid;\n  font-size: 14px;\n  box-sizing: border-box;\n\n  &:active {\n    background: ", ";\n    color: ", ";\n  }\n\n  &.circular {\n    width: 40px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
});
exports.Primary = styled_components_1.default(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-color: transparent;\n  color: ", ";\n  background: ", ";\n\n  &:disabled {\n    background: ", ";\n    color: ", ";\n  }\n\n  &:not(:disabled) {\n    &:hover {\n      background: ", ";\n      color: ", ";\n    }\n  }\n"], ["\n  border-color: transparent;\n  color: ", ";\n  background: ", ";\n\n  &:disabled {\n    background: ", ";\n    color: ", ";\n  }\n\n  &:not(:disabled) {\n    &:hover {\n      background: ", ";\n      color: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
});
exports.Secondary = styled_components_1.default(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-color: ", ";\n  color: ", ";\n  background: ", ";\n\n  &:disabled {\n    background: ", ";\n    color: ", ";\n    border-color: ", ";\n  }\n\n  &:not(:disabled) {\n    &:hover {\n      background: ", ";\n      color: ", ";\n    }\n  }\n"], ["\n  border-color: ", ";\n  color: ", ";\n  background: ", ";\n\n  &:disabled {\n    background: ", ";\n    color: ", ";\n    border-color: ", ";\n  }\n\n  &:not(:disabled) {\n    &:hover {\n      background: ", ";\n      color: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
});
exports.Tertiary = styled_components_1.default(Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border-color: ", ";\n  color: ", ";\n  background: ", ";\n\n  &:disabled {\n    background: ", ";\n    color: ", ";\n  }\n\n  &:not(:disabled) {\n    &:hover {\n      background: ", ";\n    }\n\n    &:focus {\n      background: ", ";\n      color: ", ";\n    }\n\n    &:active {\n      background: ", ";\n      color: ", ";\n    }\n  }\n"], ["\n  border-color: ", ";\n  color: ", ";\n  background: ", ";\n\n  &:disabled {\n    background: ", ";\n    color: ", ";\n  }\n\n  &:not(:disabled) {\n    &:hover {\n      background: ", ";\n    }\n\n    &:focus {\n      background: ", ";\n      color: ", ";\n    }\n\n    &:active {\n      background: ", ";\n      color: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.dark;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=styles.js.map